var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7065 5.35929L6.31598 9.74982C5.79528 10.2705 5.79528 11.1147 6.31598 11.6354C6.83668 12.1561 7.6809 12.1561 8.2016 11.6354L12.4777 7.24491C13.5191 6.20351 13.5191 4.51507 12.4777 3.47368C11.4363 2.43228 9.7479 2.43228 8.7065 3.47368L4.43036 7.8642C2.86826 9.4263 2.86826 11.959 4.43036 13.5211C5.99246 15.0832 8.52512 15.0832 10.0872 13.5211L14.2588 9.35929",
    stroke: "#059669",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/PaperClip.7be5e2ab1313dfc39f1e97d0703e2a02.svg";
export { ForwardRef as ReactComponent };